import axios from 'axios'

const baseDomain = 'https://us-central1-malta-b890d.cloudfunctions.net';
const baseURL = `${baseDomain}/`
export default axios.create({
  baseURL,
  headers: {'Content-Type' : 'application/json' , 'Authorization': `Bearer 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`}
});
